module.exports = __webpack_public_path__ + "img/0.0dbb43f2.png";